import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit, inject } from '@angular/core';
import { MatTabNavPanel, MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatBadgeModule } from '@angular/material/badge';
import { combineLatest, map, Observable, share } from 'rxjs';
import { NavLink } from '@data-terminal/shared-models/navigation';
import {
    getNavLinks,
    isCustomTab,
    isOnlinePressView,
    isSecondLevel,
    NavigationService,
} from '@data-terminal/data-access/navigation/navigation.service';
import { StandardNavigationTabComponent } from './standard-navigation-tab/standard-navigation-tab.component';
import { OperationNavigationTabComponent } from './operation-navigation-tab/operation-navigation-tab.component';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavigationComponent implements OnInit {
    private readonly navigationService = inject(NavigationService);

    @Input() tabPanel!: MatTabNavPanel;

    public subNavLinks$?: Observable<NavLink[]>;
    public customTab$?: Observable<string | undefined>;
    public isSubNavVisible$?: Observable<boolean>;

    public ngOnInit(): void {
        this.subNavLinks$ = this.navigationService.navData$.pipe(getNavLinks);
        this.customTab$ = this.navigationService.navData$.pipe(isCustomTab);
        this.isSubNavVisible$ = combineLatest([
            this.navigationService.navData$.pipe(isSecondLevel, share()),
            this.navigationService.navData$.pipe(isOnlinePressView, share()),
        ]).pipe(
            map(([secondLevel, onlinePressView]) => {
                return secondLevel || onlinePressView;
            })
        );
    }
}

@NgModule({
    declarations: [NavigationComponent, StandardNavigationTabComponent, OperationNavigationTabComponent],
    exports: [NavigationComponent],
    imports: [MatTabsModule, CommonModule, RouterModule, TranslateModule, MatBadgeModule],
})
export class NavigationComponentModule {}
